import { createContext, useEffect, useState } from "react";
import api from "services/api";
import { ENDPOINT_LOGIN, ENDPOINT_PROFILE_PERMISSION, ENDPOINT_CONFIGURATION } from "constants/environment";
import { ROUTES } from "constants/routes-path";
import { KEYS } from "constants/keys";

export const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [showKeepConnected, setShowKeepConnected] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem(KEYS.token);
    const user = localStorage.getItem(KEYS.user);
    globalConfigKeepConnected();
    if (token && user) {
      fetchUserData(user);
    }
  }, []);

  const fetchUserData = async (user) => {
    try {
      const userLogged = JSON.parse(user);
      setUser(userLogged);
    } catch (error) {
      logout();
    }
  };

  const getUserData = () => {
    try {
      const user = localStorage.getItem(KEYS.user);
      return JSON.parse(user);
    } catch (error) {
      return null;
    }
  }

  const login = async (email, password) => {
    try {
      const response = await api.post(ENDPOINT_LOGIN, { login: email, senha: password });
      localStorage.setItem(KEYS.token, response.data.token);
      
      const profilePermission = await api.get(ENDPOINT_PROFILE_PERMISSION);
      const permissionSiglas = profilePermission.data?.flatMap(profile => profile.permissoes?.map((perm) => perm.sigla) ?? []) ?? [];
      const profileDescricoes = profilePermission.data?.map(profile => profile.descricao).filter(Boolean) ?? [];
      const uniquePermissions = [...new Set([...permissionSiglas, ...profileDescricoes])];
      response.data.profilesPermissions = uniquePermissions;
      localStorage.setItem(KEYS.user, JSON.stringify(response.data));
      setUser(response.data);
      return response.data;
    } catch (error) {
        if (error?.code === "ERR_NETWORK") {
            throw "login.messages.errors.connection-refused";
        }
        throw error.response?.data?.message || "login.messages.errors.invalid-credentials";
    }
  };

  const logout = () => {
    localStorage.removeItem(KEYS.token);
    localStorage.removeItem(KEYS.user);
    setUser(null);
    window.location.href = ROUTES.login;
  };

  const globalConfigKeepConnected = async () => {
    try {
      const response = await api.get(ENDPOINT_CONFIGURATION);
      setShowKeepConnected(response.data.keep_connected)
    } catch (error) {
      setShowKeepConnected(false);
    }
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, getUserData, showKeepConnected }}>
      {children}
    </AuthContext.Provider>
  );
};
